module.exports = __webpack_public_path__ + "static/media/Logo_retim.69f2ff56.svg";